import { check_uid, checkUid, unifiedCheckUid } from '@/api/detail'
import { region, getQuery } from '@/utils/utils'
import { checkUser } from '@/api/coda'
import { globalVariable } from '@/utils/exportVariable'
import { number8Reg } from '@/utils/regExp'

export function uidAsyncValidator(uid, gameName, cpServerId, config = {}) {
  switch (gameName) {
    case 'state-of-survival':
      return commonCheckUid({ gameName, uid, cpServerId }, config)
    case 'freefire':
      if (region() === 'in') {
        return freefireCheckUid_in({ gameName, uid }, config)
      }
      break
    case 'free-fire':
      if (region() === 'id' || region() === 'th') {
        return commonCheckUid({ gameName, uid }, config)
      }
      break
    case 'shining-nikki':
      return freefireCheckUid_id({ gameName, uid }, config)
    case 'mobile-legends':
      return freefireCheckUid_id({ gameName }, config)
    default:
      return defaultCheckUid({ gameName, uid }, config)
  }
}

function commonCheckUid({ gameName, uid, cpServerId }, config) {
  const serverid = cpServerId
  const { showLoading = false, showErrorToast = false } = config || {}
  return checkUid(
    {
      game: gameName,
      country: region(),
      uid,
      cpServerId,
    },
    {
      showLoading,
      showErrorToast,
    }
  )
    .then((data) => {
      const {
        status,
        nick,
        cpServerId,
        // account,
        cateProducts,
        serverName,
        roles = [],
        skuIds = [], // GOK 需要
        accountId,
      } = data
      if (status === 1) {
        if (gameName === 'free-fire') {
          // 返回的游戏昵称是一个列表，取第一个
          const { roleId, roleName } = roles[0]
          return {
            res: true,
            uid,
            roleId,
            nick: roleName,
          }
        } else {
          return {
            res: true,
            // nick: nick ? nick : account,
            nick,
            serverName: serverName ? serverName : '',
            cpServerId: cpServerId || serverid,
            uid,
            cateProducts,
            skuIds,
            roles,
            accountId,
          }
        }
      }
      return { res: false }
    })
    .catch((error) => {
      return {
        errorCode: error.code,
      }
    })
}
function defaultCheckUid({ gameName, uid }) {
  return check_uid(uid, gameName)
    .then(({ code, roleid, flowid }) => {
      if (code === 200) {
        // 校验成功
        return {
          res: true,
          roleid,
          flowid,
          uid,
        }
      } else {
        // 校验失败
        return {
          res: false,
        }
      }
    })
    .catch(() => {
      return {
        res: false,
      }
    })
}

function freefireCheckUid_in({ uid }) {
  if (!number8Reg.test(uid)) {
    return Promise.reject({ res: false })
  } else {
    return Promise.resolve({
      res: true,
      uid,
    })
  }
}

function freefireCheckUid_id({ gameName, uid }, config = {}) {
  const { selectedSkuInfo, selectedPaymentInfo, isIAP } =
    globalVariable.store.state || {}
  const { skuId, skuName, originalPrice } = selectedSkuInfo || {}
  const {
    channelId,
    channelName,
    channel,
    subChannel,
    channelPrice: payPrice,
  } = selectedPaymentInfo || {}
  let zoneid = '',
    userid = ''
  userid = uid
  if (gameName === 'mobile-legends') {
    const { gameUid, gameZoneId } = globalVariable.store.state || {}
    userid = gameUid
    zoneid = gameZoneId

    if (!userid || !zoneid) {
      return Promise.reject({ res: false })
    }
  }
  return checkUser(
    {
      skuId,
      skuName,
      channelId,
      channelName,
      channel,
      subChannel,
      game: gameName,
      payPrice: isIAP ? originalPrice : payPrice,
      country: region(),
      source: getQuery('source') || 'ns',
      uid: userid,
      cpServerId: zoneid,
    },
    {
      ...config,
    }
  )
    .then((res) => {
      const { uid, status, nick, cpOrderNo, cpServerId } = res || {}
      if (status * 1 === 1) {
        return {
          res: true,
          uid: uid || userid,
          nick,
          cpOrderNo,
          cpServerId: cpServerId || zoneid,
        }
      } else {
        return {
          res: false,
        }
      }
    })
    .catch((err) => {
      const { code } = err || {}
      return {
        res: false,
        errorCode: code,
      }
    })
}

// 所有的CP 统一成一个接口、包括参数的统一、接口返回值的统一等
export async function injectionCheckUid(args = {}, config = {}) {
  const {
    gameName = '',
    uid = '',
    skuName = '',
    skuId = '',
    payPrice = '',
    source = '',
    cpServerId = '',
    serverName = '',
    cpProductInfo = '',
  } = args

  const parames = {
    skuId,
    skuName,
    game: gameName,
    payPrice,
    country: region(),
    source,
    uid,
    cpServerId,
    serverName,
    cpProductInfo,
  }

  try {
    const result = await unifiedCheckUid(parames, {
      ...config,
    })

    if (result.status * 1 === 1) {
      const nick =
        result.nick !== ''
          ? result.nick
          : result.roles.length
          ? result.roles
          : result.nick

      return {
        skuIds: result.skuIds,
        res: true,
        uid: result.uid,
        nick,
        cpServerId: result.cpServerId,
        accountId: result.accountId, // 目前只有[kungfu-legend] 使用
        serverName: result.serverName,
        cateProducts: result.cateProducts,
      }
    }
    return {
      res: false,
    }
  } catch (error) {
    const { code } = error || {}
    return {
      res: false,
      errorCode: code,
    }
  }
}
